/*
 * Shared parsing for CMS reference-id fields.
 *
 * `GDISizeGuidesBlock.CategoryId`, the `GDIPDPPage` wrapper `ReferenceId` and
 * the `GDIPLPPage` wrapper `CategoryId` each accept either a single id or a
 * comma-separated list, so one authored block can be reused across several
 * categories / products without duplicating its content.
 *
 *   CategoryId: "gar-tops-size-chart_alphabetical, gar-dresses-size-chart"
 *
 * Comparison is trimmed and case-insensitive; empty entries are ignored.
 */

const normalizeId = (id) => (typeof id === 'string' ? id.trim().toLowerCase() : '')

/** Splits a CMS reference field into its individual ids. */
export const parseIdList = (value) => {
    if (typeof value !== 'string') return []
    return value
        .split(',')
        .map((entry) => entry.trim())
        .filter(Boolean)
}

/** True when `id` is one of the ids listed in the CMS reference field. */
export const idListIncludes = (value, id) => {
    const target = normalizeId(id)
    if (!target) return false
    return parseIdList(value).some((entry) => normalizeId(entry) === target)
}

/** True when any of `ids` (Array or Set) is listed in the CMS reference field. */
export const idListIncludesAny = (value, ids) => {
    if (!ids) return false
    const candidates = ids instanceof Set ? Array.from(ids) : ids
    if (!Array.isArray(candidates)) return false
    return candidates.some((id) => idListIncludes(value, id))
}

/** Index of `id` within `ids`, compared the same way as the list helpers. */
export const indexOfId = (ids, id) => {
    const target = normalizeId(id)
    if (!target || !Array.isArray(ids)) return -1
    return ids.findIndex((entry) => normalizeId(entry) === target)
}
